import {
    GetCompaniesResponse,
    GetSingleTrackFoldersResponse,
    CreateSingleTrackFolderResponse,
    UpdateSingleTrackFolderResponse,
    DeleteSingleTrackFolderResponse,
    UpdateCompanyThemePWAResponse,
    GetSingleTrackFirstFiltersResponse,
    CreateSingleTrackFirstFilterResponse,
    UpdateSingleTrackFirstFilterResponse,
    DeleteSingleTrackFirstFilterResponse,
} from "../types/requestsOutputs";
import {
    CreateSingleTrackFolderParams,
    UpdateSingleTrackFolderParams,
    DeleteSingleTrackFolderParams,
    GetSingleTrackFoldersParams,
    UpdateCompanyThemePWAParams,
    CreateSingleTrackFirstFilterParams,
    UpdateSingleTrackFirstFilterParams,
    DeleteSingleTrackFirstFilterParams,
    GetSingleTrackFirstFiltersParams,
} from "../types/requestInputs";
import { fetchAPI } from "./utils";

export const getCompanies = async (): Promise<GetCompaniesResponse> => {
    return fetchAPI<GetCompaniesResponse>("/get-companies", "GET");
};

// Get company info for current user
export const getCompanyThemePWA = async ({ token }: { token: string }) => {
    return fetchAPI("/get-company-theme-pwa", "GET", undefined, token);
};

// Single Track Folder APIs
export const createSingleTrackFolder = async ({
    token,
    data,
}: CreateSingleTrackFolderParams): Promise<CreateSingleTrackFolderResponse> => {
    return fetchAPI<CreateSingleTrackFolderResponse>("/create-single-track-folder", "POST", data, token);
};

export const updateSingleTrackFolder = async ({
    token,
    data,
}: UpdateSingleTrackFolderParams): Promise<UpdateSingleTrackFolderResponse> => {
    return fetchAPI<UpdateSingleTrackFolderResponse>("/update-single-track-folder", "POST", data, token);
};

export const deleteSingleTrackFolder = async ({
    token,
    data,
}: DeleteSingleTrackFolderParams): Promise<DeleteSingleTrackFolderResponse> => {
    return fetchAPI<DeleteSingleTrackFolderResponse>("/delete-single-track-folder", "POST", data, token);
};

export const getSingleTrackFolders = async ({
    token,
    data,
}: GetSingleTrackFoldersParams): Promise<GetSingleTrackFoldersResponse> => {
    return fetchAPI<GetSingleTrackFoldersResponse>(`/get-single-track-folders`, "POST", data, token);
};

// Company Theme PWA API
export const updateCompanyThemePWA = async ({
    token,
    data,
}: UpdateCompanyThemePWAParams): Promise<UpdateCompanyThemePWAResponse> => {
    return fetchAPI<UpdateCompanyThemePWAResponse>("/update-company-theme-pwa", "POST", data, token);
};

// Single Track First Filter APIs
export const createSingleTrackFirstFilter = async ({
    token,
    data,
}: CreateSingleTrackFirstFilterParams): Promise<CreateSingleTrackFirstFilterResponse> => {
    return fetchAPI<CreateSingleTrackFirstFilterResponse>("/create-single-track-first-filter", "POST", data, token);
};

export const updateSingleTrackFirstFilter = async ({
    token,
    data,
}: UpdateSingleTrackFirstFilterParams): Promise<UpdateSingleTrackFirstFilterResponse> => {
    return fetchAPI<UpdateSingleTrackFirstFilterResponse>("/update-single-track-first-filter", "POST", data, token);
};

export const deleteSingleTrackFirstFilter = async ({
    token,
    data,
}: DeleteSingleTrackFirstFilterParams): Promise<DeleteSingleTrackFirstFilterResponse> => {
    return fetchAPI<DeleteSingleTrackFirstFilterResponse>("/delete-single-track-first-filter", "POST", data, token);
};

export const getSingleTrackFirstFilters = async ({
    token,
    data,
}: GetSingleTrackFirstFiltersParams): Promise<GetSingleTrackFirstFiltersResponse> => {
    return fetchAPI<GetSingleTrackFirstFiltersResponse>(`/get-single-track-first-filters`, "POST", data, token);
};
